import { render } from "./CustomerEditTicket.vue?vue&type=template&id=199a0a03&scoped=true"
import script from "./CustomerEditTicket.vue?vue&type=script&lang=js"
export * from "./CustomerEditTicket.vue?vue&type=script&lang=js"

import "./CustomerEditTicket.vue?vue&type=style&index=0&id=199a0a03&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199a0a03"]])

export default __exports__